import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-marketing',
  templateUrl: './show-marketing.component.html',
  styleUrls: ['./show-marketing.component.scss'],
})
export class ShowMarketingComponent implements OnInit {
  marketing = '';

  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    const admin = await this.db.doc$('master/masterInfo').pipe(take(1)).toPromise();
    this.marketing = admin.termsInfo.marketing;
  }
}
